import { render, staticRenderFns } from "./messageTemplateList.vue?vue&type=template&id=1d2d39d1"
import script from "./messageTemplateList.vue?vue&type=script&lang=js"
export * from "./messageTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports